export function calcPorterage({ weight, floors, elevator, stairsRate, elevatorRate }) {
  const w = parseFloat(String(weight ?? '').replace(/,/g, ''));
  const f = Math.max(0, parseInt(floors, 10) || 0);
  if (!Number.isFinite(w) || w <= 0 || f <= 0) {
    return { total: 0, weight: Number.isFinite(w) && w > 0 ? w : 0, floors: f, elevator: !!elevator, rate: 0 };
  }
  const rate = elevator ? Number(elevatorRate) || 0 : Number(stairsRate) || 0;
  return { total: Math.round(w * rate * f), weight: w, floors: f, elevator: !!elevator, rate };
}

export default function PorterCalculator({
  weight,
  floors,
  elevator,
  onElevatorChange,
  stairsRate,
  elevatorRate,
}) {
  const { total, rate } = calcPorterage({ weight, floors, elevator, stairsRate, elevatorRate });
  const hasWeight = Number(String(weight ?? '').replace(/,/g, '')) > 0;

  return (
    <div className="rounded-xl border border-gray-200 bg-white p-4 space-y-3">
      <h3 className="font-bold text-nexolog-navy">מחשבון סבלות</h3>
      <p className="text-sm text-gray-600">
        המשקל נלקח מההזמנה. יש לבחור קומה ואם יש מעלית.
      </p>
      <div className="text-sm">
        משקל הזמנה:{' '}
        <strong>{hasWeight ? `${Number(String(weight).replace(/,/g, '')).toLocaleString('he-IL')} ק״ג` : 'לא זמין ב-Lionwheel'}</strong>
      </div>
      <label className="flex items-start gap-2 text-sm cursor-pointer">
        <input
          type="checkbox"
          checked={!!elevator}
          onChange={(e) => onElevatorChange(e.target.checked)}
          className="accent-nexolog-teal"
        />
        <span>יש מעלית בבניין</span>
      </label>
      <div className="rounded-xl bg-nexolog-navy text-white p-4">
        <div className="flex justify-between text-sm text-gray-200">
          <span>{elevator ? 'תעריף עם מעלית' : 'תעריף ללא מעלית'}</span>
          <span>{rate} ₪ לק״ג × קומה</span>
        </div>
        <div className="flex justify-between items-center mt-3 pt-3 border-t border-white/20 text-xl font-bold">
          <span>סה״כ סבלות</span>
          <span>{total.toLocaleString('he-IL')} ₪</span>
        </div>
        <p className="mt-3 text-xs text-gray-200 leading-relaxed">
          הסכום ישולם במזומן / Bit / Paybox ישירות לשליח. יש להכין סכום מדויק.
        </p>
      </div>
    </div>
  );
}
